import React, { useState, useEffect } from "react";
import styled from "styled-components";

import StyledContainerWrapper from "../shared/StyledContainerWrapper";

import { StyledDesc3 } from "../shared/StyledTypography";
import { removePadd, mobileContainerWrapper } from "../shared/CommonStyled";
import { COLORS } from "../../globals/designSystem";
import { mq } from "../../globals/utils";

import githubBrands from "../../images/github-brands-gray.svg";
import twitterBrands from "../../images/twitter-brands-gray.svg";
import discordBrands from "../../images/discord-brands-gray.svg";
import facebookBrands from "../../images/facebook-brands-gray.svg";
import instagramBrands from "../../images/instagram-brands-gray.svg";
import youtubeBrands from "../../images/youtube-brands-gray.svg";
import linkedinBrands from "../../images/linkedin-brands-gray.svg";

const StyledCopyWriterWrapper = styled.div`
  padding: 22px 0;
  padding-bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .copyWrite {
    font-size: 12px;
  }
  .cloudStatusWrapper {
    background-color: ${COLORS.neutral_4};
    padding: 12px 16px;
    border-radius: 8px;
    width: fit-content;
    .cloudStatus {
      display: flex;
      align-items: center;
      .greenCircle {
        background-color: ${COLORS.green_60};
        border-radius: 50%;
        height: 8px;
        width: 8px;
        margin: 0 4px;
      }
      .greenColor {
        color: ${COLORS.green_60};
      }
    }
  }
  .footerSocialIconsWrapper {
    display: flex;
    align-items: center;
    .socialBrands {
      margin: 0 10px;
      opacity: 0.8;
      &:hover {
        opacity: 1;
      }
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  @media(max-width: 850px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px 0;
    .cloudStatusWrapper {
      margin-left: auto;
    }
  }
  ${mq.below.md} {
    grid-template-columns: 1fr;
    padding: 30px 0 90px;
    .brand {
      padding-bottom: 16px;
    }
    .footerSocialIconsWrapper {
      justify-content: center;
    }
    .cloudStatusWrapper {
      margin: 0 auto;
    }
    .copyWrite {
      text-align: center;
    }
  }
  @media(max-width: 356px) {
    .cloudStatusWrapper {
      display: none;
    }
    .copyWrite {
      padding-bottom: 16px;
    }
  }
`;

const CopyWriter = ({ learnPage, isDarkMode }) => {
  const [isError, setIsError] = useState(false);
  const [isItems, setIsItems] = useState(null);
  useEffect(() => {
    // if (window.Intercom) {
    //   const interCom = window.Intercom;
    //   const showIntercom = () => {
    //     return interCom("show");
    //   };
    //   showIntercom();
    // }
    fetch("https://status.hasura.io/api/v2/status.json")
      .then(res => res.json())
      .then(
        result => {
          setIsItems(result);
          setIsError(false);
        },
        error => {
          setIsError(true);
        }
      );
  }, []);
  return (
    <StyledContainerWrapper css={learnPage ? removePadd : null}>
      <div css={learnPage ? mobileContainerWrapper : null}>
        <StyledCopyWriterWrapper>
          <div className="footerSocialIconsWrapper">
            <div className="socialBrands">
              <a
                href="https://github.com/hasura/graphql-engine"
                rel="noopener noreferrer"
                aria-label="Github"
              >
                <img loading="lazy" src={githubBrands} alt="Github" />
              </a>
            </div>
            <div className="socialBrands">
              <a
                href="https://twitter.com/hasurahq"
                rel="noopener noreferrer"
                aria-label="Twitter"
              >
                <img loading="lazy" src={twitterBrands} alt="Titter" />
              </a>
            </div>
            <div className="socialBrands">
              <a
                href="https://discord.com/invite/hasura"
                rel="noopener noreferrer"
                aria-label="Discord"
              >
                <img loading="lazy" src={discordBrands} alt="Discord" />
              </a>
            </div>
            <div className="socialBrands">
              <a
                href="https://www.facebook.com/HasuraHQ"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <img loading="lazy" src={facebookBrands} alt="Facebook" />
              </a>
            </div>
            <div className="socialBrands">
              <a
                href="https://www.instagram.com/hasurahq/?hl=en"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <img loading="lazy" src={instagramBrands} alt="Instagram" />
              </a>
            </div>
            <div className="socialBrands">
              <a
                href="https://www.youtube.com/channel/UCZo1ciR8pZvdD3Wxp9aSNhQ"
                rel="noopener noreferrer"
                aria-label="Youtube"
              >
                <img loading="lazy" src={youtubeBrands} alt="Youtube" />
              </a>
            </div>
            <div className="socialBrands">
              <a
                href="https://www.linkedin.com/company/hasura"
                rel="noopener noreferrer"
                aria-label="Linkedin"
              >
                <img loading="lazy" src={linkedinBrands} alt="Linkedin" />
              </a>
            </div>
          </div>
          {isItems && !isError ? (
            <a className="cloudStatusWrapper" href="https://status.hasura.io/" target="_blank" rel="noopener noreferrer">
              <StyledDesc3 className="cloudStatus" variant="neutral_74" fontWeight="font_400">
                Cloud Status:
                <div className="greenCircle"></div>
                <span className="greenColor">{isItems?.status.description}</span>
              </StyledDesc3>
            </a>
          ) : null}
          <StyledDesc3 variant="neutral_60" className="copyWrite" fontWeight="font_400">© {new Date().getFullYear()} Hasura Inc. All rights reserved</StyledDesc3>
        </StyledCopyWriterWrapper>
      </div>
    </StyledContainerWrapper>
  );
};

export default CopyWriter;
